import { Grid } from '@achieve/ascend'
import { useState } from 'react'
import { TooltipMonthlyIncome } from '../Tooltips'
import { TooltipMonthlyExpenses } from '../Tooltips'
import { FormTextInput } from '../FormTextInput'
import { TooltipEstimatedCredit } from '../Tooltips'

export const FormIncomeExpenses = ({
  incomeFormTitle = '',
  minIncomeValue = 0,
  maxIncomeValue = 0,
  debtFormTitle = '',
  minDebtValue = 0,
  maxDebtValue = 0,
  creditCardTitle = '',
  minCreditValue = 0,
  maxCreditValue = 0,
  onChangeIncome = () => {},
  onChangeExpenses = () => {},
  onChangeCredit = () => {},
  enableSubmit,
  ...props
}) => {
  const [incomeFilled, setIncomeFilled] = useState(false)
  const [debtFilled, setDebtFilled] = useState(false)

  const handleIncomeChange = (value) => {
    onChangeIncome(value)
    setIncomeFilled(value >= minIncomeValue && value <= maxIncomeValue)
  }

  const handleDebtChange = (value) => {
    onChangeExpenses(value)
    setDebtFilled(value >= minDebtValue && value <= maxDebtValue)
  }

  return (
    <Grid
      gap={2}
      container
      flexDirection="column"
      data-testid={props?.['data-testid'] || 'dti-input-form-container'}
    >
      <Grid data-testid="dti-income-input-container">
        <FormTextInput
          title={incomeFormTitle}
          disable={false}
          tooltipComponent={<TooltipMonthlyIncome />}
          index={1}
          onChange={handleIncomeChange}
          initialValue={0}
          minValue={minIncomeValue}
          maxValue={maxIncomeValue}
          data-testid="dti-income-input"
        />
      </Grid>
      <Grid data-testid="dti-debt-input-container">
        <FormTextInput
          title={debtFormTitle}
          disable={!incomeFilled}
          tooltipComponent={<TooltipMonthlyExpenses />}
          index={2}
          onChange={handleDebtChange}
          initialValue={0}
          minValue={minDebtValue}
          maxValue={maxDebtValue}
          data-testid="dti-debt-input"
        />
      </Grid>
      <Grid data-testid="dti-credit-input-container">
        <FormTextInput
          title={creditCardTitle}
          disable={!debtFilled}
          tooltipComponent={<TooltipEstimatedCredit />}
          index={3}
          enableSubmit={enableSubmit}
          onChange={onChangeCredit}
          initialValue={0}
          minValue={minCreditValue}
          maxValue={maxCreditValue}
          data-testid="dti-credit-input"
        />
      </Grid>
    </Grid>
  )
}
